export const GET_DRIVERS = "GET_DRIVERS";
export const GET_DRIVERS_SUCCESS = "GET_DRIVERS_SUCCESS";
export const GET_DRIVERS_FAIL = "GET_DRIVERS_FAIL";
export const UPDATE_DRIVERS_LIST = "UPDATE_DRIVERS_LIST";

export const GET_DRIVER_VIEW = "GET_DRIVER_VIEW";
export const GET_DRIVER_VIEW_SUCCESS = "GET_DRIVER_VIEW_SUCCESS";
export const GET_DRIVER_VIEW_FAIL = "GET_DRIVER_VIEW_FAIL";
